export const it_IT = {
  languageType: "it_IT",
  Property_Cloths: "Tessuti",
  Settings_Language: "Lingua",
  Tab_Shop: "Shop",
}